import QuickAddModal from '@/modules/quick-add';
import '@/modules/pdp-quick-add/pdp-quick-add.scss';

if (document.getElementsByTagName('quick-add-modal')) {
    customElements.define('quick-add-modal', QuickAddModal);
}